import { useTranslations } from './translations';
import { convertToLink } from './convert-to-link';
export function replaceContentFromVariable(html, t) {
  if (!html) return html;

  if (typeof document === 'undefined') return html;

  const tpl = document.createElement('template');
  tpl.innerHTML = html;
  const translations = useTranslations();

  const nodes = tpl.content.querySelectorAll('[data-translation]');

  for (const el of Array.from(nodes)) {
    const key = el.getAttribute('data-translation') || '';
    const translated = convertToLink(translations.t(key));
    el.innerHTML = translated;
  }
  return tpl.innerHTML;
}
